import { CardListContainer, MobileSwiper } from 'ui';
import { useResolution } from 'ui/hooks';

import { Annex } from '~/data';

import { AnnexCard } from '../detail/AnnexCard';

interface Props {
  list: Annex[];
  contractNumber: string;
  customerName: string;
}

export const ContractAnnexes = ({ list, contractNumber, customerName }: Props) => {
  const { isDesktop } = useResolution();

  const cardsList = list.map((annex) => {
    return (
      <AnnexCard
        key={`${contractNumber}-${annex.annexNumber}`}
        annex={annex}
        contractNumber={contractNumber}
        customerName={customerName}
      />
    );
  });

  return isDesktop ? <CardListContainer elements={cardsList} /> : <MobileSwiper elements={cardsList} />;
};
